module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user != '') ? _c('div', {
    staticClass: "wrapper"
  }, [_c('HTMLHeader'), _vm._v(" "), _c('div', {
    staticClass: "user-header container"
  }, [_c('div', {
    staticClass: "photo-and-data"
  }, [_c('div', {
    staticClass: "photo",
    style: ({
      'background-image': 'url(\'assets/img/' + _vm.user.photo + '\')'
    })
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_c('div', {
    staticClass: "block bottom"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n            " + _vm._s(_vm.user.name) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "birthdate"
  }, [_vm._v("\n            (" + _vm._s(_vm.user.birthdate) + ")\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "block center"
  }, [_c('div', {
    staticClass: "user-type student"
  }, [_vm._v("\n            " + _vm._s(_vm.user.type) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "evaluation-wrapper"
  }, [_c('div', {
    staticClass: "bar-wrapper"
  }, [_c('div', {
    staticClass: "bar-bg"
  }, [_c('div', {
    staticClass: "bar",
    style: ({
      'background-color': _vm.user.bar_color,
      width: _vm.user.evaulation + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                " + _vm._s(_vm.user.evaulation) + "%\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              Elérhetőségek\n            ")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v(_vm._s(_vm.user.address))]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(_vm._s(_vm.user.phone))]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.user.email
    }
  }, [_vm._v(_vm._s(_vm.user.email))])])])])])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "user-header-info"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "metadata"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v("\n            " + _vm._s(_vm.user.publications.amount) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_vm._v("\n            Publikáció\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v("\n            " + _vm._s(_vm.user.watched) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_vm._v("\n            Megtekintés\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v("\n            " + _vm._s(_vm.user.languages.amount) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_vm._v("\n            Nyelvismeret\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "submenu clearfix"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', [_c('li', {
    class: {
      active: _vm.subpage == 'main'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function () {
        _vm.subpage = 'main'
      }
    }
  }, [_vm._v("Összesítő")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.subpage == 'publications'
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function () {
        _vm.subpage = 'publications'
      }
    }
  }, [_vm._v("Publikációk")])])])])]), _vm._v(" "), (_vm.subpage == 'main' && _vm.user != '') ? _c('mainPage', {
    attrs: {
      "user": _vm.user,
      "changeSubPage": _vm.changeSubPage,
      "changePublicationID": _vm.changePublicationID
    }
  }) : _vm._e(), _vm._v(" "), (_vm.subpage == 'comments') ? _c('comments', {
    attrs: {
      "user": _vm.user,
      "changeSubPage": _vm.changeSubPage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.subpage == 'publications' && _vm.publication_id == 0) ? _c('publications', {
    attrs: {
      "user": _vm.user,
      "changeSubPage": _vm.changeSubPage,
      "changePublicationID": _vm.changePublicationID
    }
  }) : _vm._e(), _vm._v(" "), (_vm.subpage == 'publications' && _vm.publication_id != 0) ? _c('publication', {
    attrs: {
      "user": _vm.user,
      "changeSubPage": _vm.changeSubPage,
      "publication_id": _vm.publication_id
    }
  }) : _vm._e(), _vm._v(" "), _c('HTMLFooter'), _vm._v(" "), _c('ProfileMenu')], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon student"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "social"
  }, [_c('a', {
    staticClass: "gp",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-google-plus"
  })]), _vm._v(" "), _c('a', {
    staticClass: "twitter",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    staticClass: "fb",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "button v2",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Üzenet küldése")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd927098"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/userpage.vue
// module id = 400
// module chunks = 0